import React, { useContext, useState } from "react";


const ResumenExamenReagendamiento = ({datosReserva}) => {
  const [isTabOpen, setIsTabOpen] = useState(true); // Estado para controlar si el contenido del tab está visible

  // Función para alternar el estado del tab
  const toggleTab = () => {
    setIsTabOpen((prevIsTabOpen) => !prevIsTabOpen);
  };

  const formatDate = (date) => {
    if (!date) {
      console.warn("Fecha inválida o no proporcionada:", date);
      return { day: null, month: null, year: null, time: null };
    }
  
    try {
      let parsedDate;
      let time = null;
  
      // Detectar si es un objeto Date
      if (date instanceof Date) {
        parsedDate = date;
        // Extraer la hora en formato HH:mm
        time = parsedDate.toTimeString().slice(0, 5);
      } else if (typeof date === "string") {
        // Manejar el caso de fecha en formato string (DD/MM/YYYY HH:mm)
        const [datePart, timePart] = date.split(" ");
        const [day, month, year] = datePart.split("/");
        if (!day || !month || !year) {
          throw new Error("Formato de fecha inválido");
        }
        parsedDate = new Date(`${year}-${month}-${day}T${timePart || "00:00"}`);
        time = timePart || null;
      } else {
        throw new Error("Tipo de dato no soportado");
      }
  
      return {
        day: parsedDate.getDate(),
        month: parsedDate.toLocaleString("es-ES", { month: "long" }),
        year: parsedDate.getFullYear(),
        time: time,
      };
    } catch (error) {
      console.error("Error al formatear la fecha:", error.message);
      return { day: null, month: null, year: null, time: null };
    }
  };
  
  
  
  const formattedDate = datosReserva?.data.json_request.parameters.rsa_fecha
    ? formatDate(datosReserva?.data.json_request.parameters.rsa_fecha)
    : null;

  return (
    <div className="row booking-resume-exam">
      <div className="col-12 pads0 mb10" id="resume-exam-1">
        <div className="col-12 resume-exam-tab" onClick={toggleTab}>
          <div className="row">
            <div className="col-10">
              <p className="mb0 resume-label">Resumen del examen</p>
            </div>
            <div className="col-2 text-center pads0">
              <p className="mb0">
                <i className={`fa ${isTabOpen ? "fa-angle-down" : "fa-angle-up"}`}></i>
              </p>
            </div>
          </div>
        </div>
        {isTabOpen && ( // Mostrar u ocultar el contenido basado en el estado
          <div className="col-12 resume-exam-data">
            <div className="row mb20" id="ovw-data">
              <div className="col-12 pl0">
                <h6 className="monts-b upper">Propósito de la visita</h6>
                <p className="mb0 desc-ovw-type">
                  {datosReserva?.data.nombre_servicio}
                </p>
              </div>
            </div>

            {/* Texto condicional para fecha y hora */}
            {datosReserva?.data.json_request.parameters.rsa_fecha && (
              <div className="row" id="ovw-date">
                <div className="col-9 mb10 pl0">
                  <h6 className="monts-b upper">Fecha y hora</h6>
                  <p className="mb0 desc-ovw-date">
                    <span className="date-month">{formattedDate.month}</span>&nbsp;
                    <span className="date-day">{formattedDate.day}</span>,&nbsp;
                    <span className="date-year">{formattedDate.year}</span>&nbsp;-&nbsp;
                    <span className="date-hour">{formattedDate.time}</span>
                  </p>
                </div>
                <div className="col-3 pads0 text-center">
                  <p className="mb0">
                    <a href="#">cambiar</a>
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="col-12 pads0 mb10" id="resume-exam-2"></div>
    </div>
  );
};

export default ResumenExamenReagendamiento;
